/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getAttendDay({ commit }, workspaceId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/attend/"+workspaceId)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('SET_ATTEND_DAYS', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAttendData({ commit }, attendId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/attend/data/"+attendId)
        .then((response) => {
          if(response.data.result == 'success'){            
            commit('SET_ATTEND_MISS_DATA', response.data.data_list.miss_students)
            commit('SET_ATTEND_LATE_DATE', response.data.data_list.late_students)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createAttendData({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/attend/create", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('CREATE_ATTEND_DAY', response.data.data)
            // commit('SET_ATTEND_DATA', payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateAttendData({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/attend/update", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('UPDATE_ATTEND_DAY', response.data.data)
            // commit('SET_ATTEND_DATA', payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  delelteAttendData({commit}, attendId){
    return new Promise((resolve, reject) => {
      axios.delete("/api/workspace/attend/", attendId)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('DELETE_ATTEND_DATA', attendId)
            // commit('SET_ATTEND_DATA', payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
